import React, { useState, useEffect } from 'react';
import { Button, DatePicker, Input, Modal } from 'antd';
import type { Dayjs } from 'dayjs';
import dayjs from 'utils/dayjs';
import s from './s.module.less';
import commonS from 'styles/common.module.less';
import { ReviewData } from '../../types';

const { TextArea } = Input;

type Props = {
    show: boolean;
    review?: ReviewData;
    onCancel: () => void;
    onSave: (review: ReviewData) => void;
};

const EditReviewModal = (props: Props) => {
    const { show, review, onCancel, onSave } = props;
    const [reviewContent, setReviewContent] = useState<string>('');
    const [date, setDate] = useState<Dayjs | null>(null);

    useEffect(() => {
        if (show && review) {
            setReviewContent(review.reviewContent);
            setDate(review.date ? dayjs(review.date) : null);
        }
    }, [show, review]);

    const handleSave = () => {
        if (!reviewContent.trim()) {
            return;
        }
        onSave({
            reviewContent: reviewContent.trim(),
            date: date ? date.format('YYYY-MM-DD') : '',
        });
    };

    const handleCancel = () => {
        setReviewContent('');
        setDate(null);
        onCancel();
    };

    // 禁用今天之后的日期
    const disabledDate = (current: Dayjs | null) => {
        if (!current) {
            return false;
        }
        // 禁用今天之后的所有日期
        return current.isAfter(dayjs(), 'day');
    };

    return (
        <Modal
            title="Edit review"
            open={show}
            onCancel={handleCancel}
            className={commonS.modalFixHeightWrap}
            width="650px"
            footer={
                <div className={s.footer}>
                    <Button onClick={handleCancel}>
                        Cancel
                    </Button>
                    <Button
                        type="primary"
                        onClick={handleSave}
                        disabled={!reviewContent.trim()}
                    >
                        Save
                    </Button>
                </div>
            }
            destroyOnClose
        >
            <div className={s.wrap}>
                <div className={s.field}>
                    <label className={s.label}>Review details</label>
                    <TextArea
                        value={reviewContent}
                        onChange={(e) => setReviewContent(e.target.value)}
                        placeholder="Enter review content"
                        rows={6}
                        className={s.textarea}
                    />
                </div>
                <div className={s.field}>
                    <label className={s.label}>Review date</label>
                    <DatePicker
                        value={date}
                        onChange={(date) => setDate(date)}
                        format="YYYY-MM-DD"
                        className={s.datePicker}
                        placeholder="Select date"
                        disabledDate={disabledDate}
                    />
                </div>
            </div>
        </Modal>
    );
};

export default EditReviewModal;

